import Shimmer from '@components/core/Shimmer/Shimmer';
import ShimmerWrapper from '@components/core/Shimmer/ShimmerWrapper';

const Title = () => {
    return <Shimmer width='100%' height={40} radius={6} />;
};

const FieldSkeleton = ({
    fieldWidth = '100%',
    fieldHeight = '32px',
    titleWidth = 60,
    titleHeight = 12,
}) => {
    return (
        <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
            <Shimmer width={titleWidth} height={titleHeight} radius={6} />
            <Shimmer width={fieldWidth} height={fieldHeight} radius={6} />
        </ShimmerWrapper>
    );
};

const RadioButtonSkeleton = ({ options = 2 }) => {
    return (
        <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='flex-start'>
            {Array.from({ length: options }).map((_, index) => (
                <ShimmerWrapper
                    key={index}
                    spacing={16}
                    width={'auto'}
                    direction='row'
                    align='flex-start'
                    justify='flex-start'
                >
                    <Shimmer width={18} height={18} radius='50%' />
                    <Shimmer width={60} height={12} radius={6} />
                </ShimmerWrapper>
            ))}
        </ShimmerWrapper>
    );
};

const CheckboxSkeleton = ({ options = 2 }) => {
    return (
        <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='flex-start'>
            {Array.from({ length: options }).map((_, index) => (
                <ShimmerWrapper
                    key={index}
                    spacing={16}
                    width={'auto'}
                    direction='row'
                    align='flex-start'
                    justify='flex-start'
                >
                    <Shimmer width={18} height={18} radius={6} />
                </ShimmerWrapper>
            ))}
        </ShimmerWrapper>
    );
};

const DropdownSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='flex-start'>
            <Shimmer width={100} height={36} radius={6} />
        </ShimmerWrapper>
    );
};

const CKEditorSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
            <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='flex-start'>
                <Shimmer width={24} height={24} radius={6} />
                <Shimmer width={24} height={24} radius={6} />
                <Shimmer width={24} height={24} radius={6} />
                <Shimmer width={24} height={24} radius={6} />
                <Shimmer width={24} height={24} radius={6} />
                <Shimmer width={40} height={24} radius={6} />
                <Shimmer width={40} height={24} radius={6} />
            </ShimmerWrapper>
            <Shimmer width='100%' height={180} radius={6} />
        </ShimmerWrapper>
    );
};

const TextareaSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
            <Shimmer width='100%' height={180} radius={6} />
        </ShimmerWrapper>
    );
};

const FieldGroupSkeleton = ({ fields = 2, columns = 1 }) => {
    return (
        <ShimmerWrapper
            spacing={16}
            display='grid'
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
            {Array.from({ length: fields }).map((_, index) => (
                <FieldSkeleton key={index} />
            ))}
        </ShimmerWrapper>
    );
};

const FormSkeleton = ({ children, title = true, spacing = 36, ...rest }) => {
    return (
        <ShimmerWrapper
            spacing={spacing}
            className={`padding-vertical`}
            direction='column'
            align='center'
            justify='space-between'
            {...rest}
        >
            {title && <Title />}
            {children}
        </ShimmerWrapper>
    );
};

const GroupButtonsSkeleton = ({ buttons = 2, title = true }) => {
    return (
        <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='flex-start'>
            {title && <Shimmer width={100} height={12} radius={6} />}
            {Array.from({ length: buttons }).map((_, index) => (
                <ShimmerWrapper key={index} spacing={16} width={'auto'} direction='row' align='flex-start' justify='flex-start'>
                    <Shimmer width={40} height={36} radius={6} />
                </ShimmerWrapper>
            ))}
        </ShimmerWrapper>
    );
};

const ButtonSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} width={'auto'} direction='row' align='flex-start' justify='flex-start'>
            <Shimmer width={40} height={36} radius={6} />
        </ShimmerWrapper>
    );
};

const BaseFormSkeleton = () => {
    return (
        <FormSkeleton>
            <FormSkeleton.FieldGroupSkeleton fields={3} columns={2} />
        </FormSkeleton>
    );
}

FormSkeleton.CheckboxSkeleton = CheckboxSkeleton;
FormSkeleton.RadioButtonSkeleton = RadioButtonSkeleton;
FormSkeleton.Title = Title;
FormSkeleton.FieldSkeleton = FieldSkeleton;
FormSkeleton.FieldGroupSkeleton = FieldGroupSkeleton;
FormSkeleton.CKEditorSkeleton = CKEditorSkeleton;
FormSkeleton.BaseFormSkeleton = BaseFormSkeleton;
FormSkeleton.TextareaSkeleton = TextareaSkeleton;
FormSkeleton.GroupButtonsSkeleton = GroupButtonsSkeleton;
FormSkeleton.ButtonSkeleton = ButtonSkeleton;
FormSkeleton.DropdownSkeleton = DropdownSkeleton;

export default FormSkeleton;
